import React from 'react';
import { IconProps } from '../Icons.interface';

export const ChevronLeft: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5182 11.9998L15.6582 17.2468C16.0743 17.6108 16.1163 18.2428 15.7522 18.6578C15.3882 19.0738 14.7563 19.1158 14.3413 18.7528L8.34125 12.7518C7.88625 12.3538 7.88625 11.6458 8.34125 11.2478L14.3413 5.24782C14.7563 4.88382 15.3882 4.92582 15.7522 5.34082C16.1163 5.75682 16.0743 6.38882 15.6582 6.75182L10.5182 11.9998Z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_712_11636"
          x1="8"
          y1="6.68962"
          x2="16.8537"
          y2="7.59025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2CBC32" />
          <stop offset="0.98762" stopColor="#07996E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
